import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2026 Festo - College Event Management. All rights reserved.</p>
        <p>Discover • Register • Celebrate</p>
      </div>
    </footer>
  );
};

export default Footer;
